import React from 'react';
import { Hero } from './components/Hero';
import { Capabilities } from './components/Capabilities';
import { Process } from './components/Process';
import { Audit } from './components/Audit';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { GridBackground } from './components/GridBackground';
import { LanguageProvider } from './contexts/LanguageContext';

export default function App() {
  return (
    <LanguageProvider>
      <div className="relative min-h-screen bg-obsidian text-mutedGray selection:bg-emerald selection:text-obsidian overflow-x-hidden font-sans">
        <GridBackground />
        <Header />
        
        <main className="relative z-10 flex flex-col items-center w-full">
          <Hero />
          <Capabilities />
          <Process />
          <Audit />
        </main>

        <Footer />
      </div>
    </LanguageProvider>
  );
}